export const formatChatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return diffMins === 1 ? '1 min ago' : `${diffMins} min ago`;
  if (diffHours < 24) return diffHours === 1 ? '1 hr ago' : `${diffHours} hr ago`;
  if (diffDays === 1) return 'Yesterday';
  if (diffDays < 7) return date.toLocaleDateString('en-US', { weekday: 'short' });
  if (date.getFullYear() === now.getFullYear()) {
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const groupChatsByDate = (chats) => {
  const groups = {
    Today: [],
    Yesterday: [],
    'This Week': [],
    'Last Week': [],
    Earlier: []
  };

  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  const thisWeekStart = new Date(now);
  thisWeekStart.setDate(thisWeekStart.getDate() - 7);
  const lastWeekStart = new Date(thisWeekStart);
  lastWeekStart.setDate(lastWeekStart.getDate() - 7);

  chats.forEach(chat => {
    const chatDate = new Date(chat.lastMessageAt || chat.createdAt);
    
    if (chatDate.toDateString() === now.toDateString()) {
      groups.Today.push(chat);
    } else if (chatDate.toDateString() === yesterday.toDateString()) {
      groups.Yesterday.push(chat);
    } else if (chatDate >= thisWeekStart) {
      groups['This Week'].push(chat);
    } else if (chatDate >= lastWeekStart) {
      groups['Last Week'].push(chat);
    } else {
      groups.Earlier.push(chat);
    }
  });

  // Return array of entries with non-empty groups
  return Object.entries(groups).filter(([_, chats]) => chats.length > 0);
}; 